// Display helpers for the Sent Messages log (BOT-1314).

export const WINDOW_OPTIONS = [7, 14]

const BADGES = {
  delivered: { label: 'Delivered', classes: 'bg-green-100 text-green-800' },
  failed: { label: 'Failed', classes: 'bg-red-100 text-red-600' },
  unsent: { label: 'Unsent', classes: 'bg-gray-100 text-gray-600' }
}

// Customer-side opt-outs: the message was never attempted, so it is "unsent"
// rather than "failed". Shown as hover text on the badge.
const UNSENT_REASONS = {
  do_not_text: 'Customer is opted out',
  block_marketing_messages: 'Customer is opted out of marketing messages'
}

// Merchant-side suppressions that never reached Twilio but still count as failed.
const SUPPRESSED_REASONS = {
  not_allowed_to_send_texts: 'This account was not allowed to send texts'
}

const AUTOMATION_PAGES = {
  MessageAutomation: '/automation/message/'
}

// Who sent a blast: a drop reminder's drop, else the automation's name, or "<kind> - <id>" when saved without one.
export function senderLabel(attrs) {
  if (attrs.drop_id) return `Drop - ${attrs.drop_description?.trim() || attrs.drop_id}`
  return attrs.automation_name?.trim() || `Automation - ${attrs.automation_id}`
}

// The page of the drop or automation that sent a blast. Null for a type the dashboard has no page for.
export function senderLink(attrs) {
  if (attrs.drop_id) return `/store/drops/${attrs.drop_id}`
  const page = AUTOMATION_PAGES[attrs.automation_type]
  return page ? page + attrs.automation_id : null
}

export function statusBadge(status) {
  return BADGES[status] || { label: 'Pending', classes: 'bg-gray-100 text-gray-600' }
}

// Hover text for the status badge. Null unless unsent.
export function statusTitle(attrs) {
  if (attrs.status !== 'unsent') return null
  return UNSENT_REASONS[attrs.send_status] || null
}

// The reason a failed entry failed: the Twilio error when the message reached
// Twilio, otherwise the send suppression that stopped it. Null unless failed.
export function failureReason(attrs) {
  if (attrs.status !== 'failed') return null
  if (attrs.error_message) {
    return attrs.error_code ? `${attrs.error_message} (Twilio ${attrs.error_code})` : attrs.error_message
  }
  if (attrs.error_code) return `Twilio error ${attrs.error_code}`
  return SUPPRESSED_REASONS[attrs.send_status] || null
}
